import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { obtenerDatosPredioByIdCliente } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { obtenerTodosLosClientesConDetalle } from "../../../redux/InformacionValidaDucks";
import { agregarNuevaListaGuia } from "../../../redux/DucksUsuarioAgricola/GuiaMagueyDucks";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";

import { useStateIfMounted } from "use-state-if-mounted";
import { v4 as uuidv4 } from 'uuid';

const PanelGenerarNuevaGuia = (props) => {
  const dispatch = useDispatch();

  let dataCliente = [];

  //const dataRegistro = useSelector((store) => store.RegistroPredioApi.data);
  dataCliente = useSelector((store) => store.InformacionValidaApi.data.data);

  let dataPredios = useSelector((store) => store.DatosPredioApi.data.data);


  //const [isVisibleGuardar, setIsVisibleGuardar] = React.useState(false);
  const [errorAgregar, setErrorAgregar] = useStateIfMounted(false);
  const [exito, setExito] = useStateIfMounted(false);
  const [alert, setAlert] = useStateIfMounted(false);
  const [msjAlert, setMsjAlert] = useStateIfMounted("");

  const [addGuia, setAddGuia] = React.useState(0);
  const [numTotalPlantas, setNumTotalPlantas] = React.useState(0);
  const [numSocio, setNumSocio] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [predio, setPredio] = React.useState({
    iddatospredio: null,
    nombrepredio: null,
    superficiehectarea: null,
    longitudoeste: null,
    latitudnorte: null,
    especie: null,
    edad: null,
    fecharegistro: null,
    estado: null,
    municipio: null,
    localidad: null,
    idtenenciatierra: null,
    idusufructotierra: null,
    representantecampo: null,
    idregistropredio: null,
    ispropietario: null,
    nombrepropietario: null,
    datosPredio: null
  });



  const [cliente, setCliente] = React.useState({
    numerosocio: null,
    personafisica: null,
    personamoral: null,
    nombrerazonsocial: null,
    fechasolicitud: null,
    rfc: null,
    telefono: null,
    correoelectronico: null,
    nombrerepresentantelegal: null,
    telefonorepresentante: null,
    correoelectronicorepresentante: null,
    empresacertificadora: null,
    idtipocliente: null,
    idlogin: null,
    idcartera: null,
    idcliente: null
  })

  const [datosPredio, setDatosPredio] = React.useState({
    nombrepredio: null,
    superficiehectarea: null,
    longitudoeste: null,
    latitudnorte: null,
    especie: null,
    edad: null,
    fecharegistro: null,
    estado: null,
    municipio: null,
    localidad: null,
    idtenenciatierra: null,
    idusufructotierra: null,
    representantecampo: null,
    idregistropredio: null,
    ispropietario: null,
    nombrepropietario: null
  })

  /* useEffect(() => {
     asociado !== null && asociado.id !== null
       ? setIsVisibleGuardar(false)
       : setIsVisibleGuardar(true);
   }, [asociado]); */


  useEffect(() => {

    dispatch(obtenerTodosLosClientesConDetalle());
  }, []);



  useEffect(() => {

    if (cliente != null && cliente.idcliente !== null) {
      dispatch(obtenerDatosPredioByIdCliente(cliente.idcliente));
    }

  }, [cliente])

  const style = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "#ddd",
    cursor: "not-allowed",
    pointerEvents: "none",
  };

  const btnGuardar = async (e) => {
    e.preventDefault()
    if (addGuia === 0) {
      setAlert(true)
      setMsjAlert("El minimo de guias a generar es: 1")
      setErrorAgregar(true)

      return
    }

    if (numTotalPlantas === 0) {
      setAlert(true)
      setMsjAlert("Para agregar guias debes tener más de 1 planta")
      setErrorAgregar(true)
    } else {
      try {
        let lista = []
        for (let index = 0; index < addGuia; index++) {
          lista.push({
            iddatospredio: predio.iddatospredio,
            constanciaruta: "",
            tipoguia: 1,
            fechacreacion: new Date(),
            usuariocreador: "",
            esactiva: true,
            identificador: uuidv4().toString().substring(0, 5)
          })
          let value = await dispatch(agregarNuevaListaGuia({ data: lista })).unwrap();
          setAlert(true)
          setMsjAlert("Registro agredado Correctamente")
          setExito(true)
          setErrorAgregar(false)
        }
      } catch (rejectedValueOrSerializedError) {
        setMsjAlert("Error")
        setErrorAgregar(true)
        setAlert(true)
        setExito(false)
      }

    }



  };

  useEffect(() => {
    sumarValoresMaguey()

  }, [predio])



  const handlerSeleccion = (value) => {
    setPredio(value);
    setCliente(value);
  };


  const sumarValoresMaguey = () => {
    if (predio != null && predio?.datosmaguey !== null && predio?.datosmaguey !== undefined) {
      const filtrados = predio.datosmaguey.map(maguey => {
        if (maguey.edad >= 5)
          return maguey
      });

      let numTotal = filtrados.reduce((a, b) => a + (b['numeroplantas'] || 0), 0);
      setNumTotalPlantas(numTotal)
    }

  }



  return (
    <Fragment>
      <br />
      <div className="container" style={{ maxWidth: 1500, paddingLeft: "15%" }}>
        <h2 className="text-center">Datos del Predio</h2>
        <div className="bg-light p-5 rounded">
          <div className="row">
            <div className="col-6">
              <h3 className="text-left">Datos del Productor</h3>
              <div className="pt-2">
                <div className="row g-3">
                  <div className="col-sm-4">
                    <label className="form-label"></label>
                    <label className="form-label">
                      <b>No. Cliente :</b>
                    </label>

                    <Autocomplete
                      freeSolo
                      open={open}
                      onOpen={() => {
                        if (numSocio) {
                          setOpen(true);
                        }
                      }}
                      onClose={() => setOpen(false)}
                      inputValue={numSocio ? numSocio : ""}
                      onInputChange={(e, value) => {
                        setNumSocio(value);

                        if (!value) {
                          setOpen(false);
                        }
                      }}
                      onChange={(event, value = "") => {
                        handlerSeleccion(value);
                      }}
                      options={dataCliente ? dataCliente : []}
                      defaultValue=""
                      getOptionLabel={(opcion) => opcion ? opcion.numerosocio + "" : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          size="small"
                          style={{ background: "white" }}
                          fullWidth
                        />
                      )}
                    />
                  </div>

                  <div className="col-sm-12">
                    <label className="form-label">
                      <b>Nombre del Predio:</b>
                    </label>

                    <Autocomplete
                      fullWidth
                      disablePortal
                      options={dataPredios !== null ? dataPredios : []}
                      getOptionLabel={(opcion) => opcion.nombrepredio}
                      onChange={(event, value) => {
                        setPredio(value)

                      }}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.iddatospredio}>
                            {option.nombrepredio}
                          </li>
                        );
                      }}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            background: "white",
                          }}
                          size="small"
                        />
                      )}
                    />
                  </div>
                  <div className="col-12"></div>
                  <div className="col-12">
                    <label className="form-label">
                      <b>No. cliente "A":</b>
                    </label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      defaultValue={""}
                      value={
                        cliente !== null && cliente.idcliente !== null ? cliente.idcliente : ""
                      }
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      <b>Nombre Cliente:</b>
                    </label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      defaultValue={""}
                      value={
                        cliente && cliente.nombrerazonsocial
                          ? cliente.nombrerazonsocial
                          : ""
                      }
                    />
                  </div>

                  <div className="col-12">
                    <label className="form-label">
                      <b>Existencia de Maguey:</b>
                    </label>
                    <TextField
                      disabled
                      fullWidth
                      sx={style}
                      size="small"
                      defaultValue={""}
                      value=
                      {
                        (numTotalPlantas !== 0) ? numTotalPlantas : ""
                      }
                    />
                  </div>
                  <div className="col-sm-12">
                    <label className="form-label"></label>
                    <label className="form-label">
                      <b>Cantidad de Guías:</b>
                    </label>
                    <TextField
                      fullWidth
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        background: "white",
                      }}
                      type="number"
                      inputProps={{
                        inputMode: "numeric",
                        min: 0,
                      }}
                      size="small"
                      defaultValue={0}
                      onChange={e => setAddGuia(e.target.value)}
                    />

                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <div align="left">
                          <Button onClick={btnGuardar} >Guardar</Button>
                        </div>
                      </div>
                      {errorAgregar && alert && (
                        <Stack sx={{ width: "100%" }} spacing={2}>
                          <Alert
                            severity="error"
                            onClose={() => {
                              setAlert(false);
                              window.location.reload(true);
                            }}
                          >
                            {msjAlert}
                          </Alert>
                        </Stack>
                      )}
                      {exito && alert && (
                        <Stack sx={{ width: "100%" }} spacing={4}>
                          <Alert
                            onClose={() => {
                              setAlert(false);
                              window.location.reload(true);
                            }}
                          >
                            {msjAlert}
                          </Alert>
                        </Stack>
                      )}
                    </div>
                  </div>
                  <div />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(PanelGenerarNuevaGuia);
